import * as Yup from "yup";

import { requiredStringUk } from "validation";

export const createCategoriesValidationSchema = Yup.object().shape({
  nameCategory: requiredStringUk,
  tokens: requiredStringUk,
});
